import { alphaClient } from '@/services/api-client'
import { VehicleRestrictionInTransit } from '@/types/VehicleRestrictionInTransit'

export const getVehicleRestrictionInTransit = (): Promise<
  VehicleRestrictionInTransit[]
> =>
  alphaClient
    .get<VehicleRestrictionInTransit[]>(
      '/custom/malartag/vehicleRestrictionInTransit'
    )
    .then((x) => x.data)
